import { ChevronDown } from "lucide-react";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { EventSpaceDetails } from "./EventSpaceDetails";

interface SpacesListProps {
  restaurant: RestaurantWithEventSpaces;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SpacesList = ({ restaurant, isOpen, onOpenChange }: SpacesListProps) => {
  return (
    <Collapsible open={isOpen} onOpenChange={onOpenChange}>
      <CollapsibleTrigger className="spaces-trigger w-full flex items-center justify-between text-sm text-gray-600 mb-2 hover:bg-accent p-2 rounded-md transition-colors">
        <span>View Available Spaces</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-2 mb-3">
        {restaurant.eventspaces?.map((space) => (
          <EventSpaceDetails key={space.id} space={space} />
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
};